var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSilver = function SvgSilver(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDCECE",
    stroke: "url(#silver_svg__a)",
    strokeWidth: 1.333,
    d: "M77.551 8.859c.813 3.054 1.228 7.817 1.437 11.865a165 165 0 0 1 .207 7.13V28h.667-.667v.146l-.003.422a165.062 165.062 0 0 1-.204 6.708c-.208 4.048-.623 8.811-1.436 11.865-.857 3.223-3.379 5.76-6.578 6.62-1.485.4-4.148.712-7.365.949-3.198.234-6.886.391-10.387.496a493 493 0 0 1-12.943.209H40v.667-.667h-.281l-.8-.003a492.631 492.631 0 0 1-12.143-.206c-3.5-.105-7.188-.261-10.386-.496-3.217-.237-5.88-.548-7.365-.949-3.2-.86-5.723-3.397-6.578-6.62-.813-3.054-1.228-7.817-1.436-11.865a165 165 0 0 1-.207-7.13V28H.136h.666v-.146l.004-.422a164.874 164.874 0 0 1 .204-6.708c.208-4.048.623-8.811 1.436-11.865.856-3.223 3.38-5.76 6.578-6.62 1.485-.401 4.148-.713 7.365-.949C19.588 1.055 23.276.9 26.777.794A493 493 0 0 1 39.719.585H40v-.667.667h.281l.8.003a492.98 492.98 0 0 1 12.142.206c3.5.105 7.189.261 10.387.496 3.216.236 5.88.548 7.364.948 3.2.86 5.722 3.398 6.578 6.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M77.213 10.443C76.665 6 73.33 3.334 69.907 2.666c-5.273-1.504-13.702-1.325-15.848-1.325l-7.03 27.903-7.031 25.422c2.147 0 24.636.106 29.908-1.398 4.092-.6 6.759-3.934 7.306-7.775 1.436-5.707 1.453-17.046 1.453-17.526s-.017-11.82-1.452-17.524"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.709 15.947v24.104L52.897 28z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "silver_svg__a",
    x1: 0.137,
    x2: 79.862,
    y1: 28,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9C98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#FFFDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#FFFDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9C98"
  })))));
};
export default SvgSilver;